import { TextState } from "@creatomate/preview";

import general from "constants/general";

const getTextFontEffect = (activeElement: TextState) => {
  const { source } = activeElement;
  if (source.background_color && !source.shadow_color && !source.stroke_color) {
    if (source.background_border_radius === "25%") {
      if (source.background_align_threshold === "0%") {
        return "Rounded background";
      }
      return "Block background";
    }
    return "Straight background";
  }
  if (!source.background_color && source.shadow_color && !source.stroke_color) {
    return "Shadow";
  }
  if (!source.background_color && !source.shadow_color && source.stroke_color) {
    if (source.stroke_width === "0.5 vmin") {
      return "Outline & Filled";
    }
    return "Outline";
  }
  return general.DEFAULT_EFFECT;
};

export default getTextFontEffect;
